module.exports = __webpack_public_path__ + "img/figure-3.d9bd9713.png";